(function(){

(function(){
  function init(root){
    if(!root||root.dataset.ppLabReady==='true')return;
    root.dataset.ppLabReady='true';
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-pp-tab]'));
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-pp-panel]'));
    var views=Array.prototype.slice.call(root.querySelectorAll('[data-pp-view]'));
    var image=root.querySelector('[data-pp-image]');
    var markers=root.querySelector('[data-pp-markers]');
    var details=Array.prototype.slice.call(root.querySelectorAll('[data-pp-detail]'));
    var popover=root.querySelector('[data-pp-popover]');
    var popoverTitle=root.querySelector('[data-pp-popover-title]');
    var popoverText=root.querySelector('[data-pp-popover-text]');
    var popoverClose=root.querySelector('[data-pp-popover-close]');
    var currentTab='forme';
    var currentView='face';
    var warmed=false;
    var cachedImages=[];
    function responsiveSource(key){return image.getAttribute('data-'+key+(window.matchMedia('(max-width:760px)').matches?'-src':'-large'));}
    function warmImages(){
      if(warmed||!image)return;warmed=true;image.loading='eager';
      ['profile','back','matieres','entretien'].forEach(function(key){var preload=new Image();preload.decoding='async';preload.fetchPriority='low';preload.sizes=image.sizes;preload.srcset=image.getAttribute('data-'+key+'-src')+' 640w, '+image.getAttribute('data-'+key+'-large')+' 1100w';preload.src=image.getAttribute('data-'+key+'-src');cachedImages.push(preload);});
    }
    if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting;})){warmImages();observer.disconnect();}},{rootMargin:'700px'});observer.observe(root);}else{warmImages();}
    var imageRequest=0;
    function setImage(key){
      var request=++imageRequest;
      var previous=image;
      var next=previous.cloneNode(false);
      // Clear the previous tab immediately; reveal only the decoded final image.
      previous.style.visibility='hidden';
      next.classList.remove('is-changing');
      next.style.visibility='visible';
      next.loading='eager';
      next.srcset=previous.getAttribute('data-'+key+'-src')+' 640w, '+previous.getAttribute('data-'+key+'-large')+' 1100w';
      next.src=previous.getAttribute('data-'+key+'-src');
      function reveal(){
        if(request!==imageRequest)return;
        next.alt=previous.alt;
        previous.replaceWith(next);
        image=next;
      }
      if(next.decode){next.decode().then(reveal).catch(function(){
        if(request!==imageRequest)return;
        if(next.complete&&next.naturalWidth)reveal();
        else next.onload=reveal;
      });}else if(next.complete&&next.naturalWidth){reveal();}else{next.onload=reveal;}
    }
    var sizeButtons=Array.prototype.slice.call(root.querySelectorAll('[data-pp-size]'));
    sizeButtons.forEach(function(button){button.addEventListener('click',function(){
      sizeButtons.forEach(function(item){item.setAttribute('aria-pressed',item===button?'true':'false');});
      root.querySelectorAll('[data-pp-size-profile]').forEach(function(profile){
        profile.setAttribute('opacity',profile.getAttribute('data-pp-size-profile')===button.dataset.height?'1':'.48');
      });
    });});
    var tabDescriptions={tailles:'Oreiller Pioupiou avec dimensions du format sélectionné',matieres:'Tissu matelassé blanc et liseré bleu Pioupiou sur fond blanc',entretien:'Oreiller Pioupiou avec fermeture ouverte et housse partiellement retirée sur fond blanc'};
    function showTabImage(){
      root.dataset.activeTab=currentTab;
      root.querySelector('[data-pp-dimensions]').toggleAttribute('hidden',currentTab!=='tailles');
      var viewBar=root.querySelector('.pp-lab__views');
      viewBar.inert=currentTab!=='forme';
      viewBar.setAttribute('aria-hidden',currentTab==='forme'?'false':'true');
      if(!image)return;
      var key=currentTab==='forme'?currentView:currentTab;
      setImage(key);
      image.alt=currentTab==='forme'?'Oreiller Pioupiou, vue '+(currentView==='face'?'du dessus':currentView==='profile'?'de côté':'de dos'):tabDescriptions[currentTab];
    }
    function updateMarkers(){if(markers)markers.hidden=!(currentTab==='forme'&&currentView==='face');}
    tabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){
        currentTab=tab.getAttribute('data-pp-tab');
        showTabImage();
        tabs.forEach(function(item){var active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false');item.tabIndex=active?0:-1;});
        panels.forEach(function(panel){var active=panel.getAttribute('data-pp-panel')===currentTab;panel.hidden=!active;panel.classList.toggle('is-active',active);});
        closeDetail(false);
        updateMarkers();
      });
      tab.addEventListener('keydown',function(event){if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();var next=event.key==='ArrowRight'?(index+1)%tabs.length:(index-1+tabs.length)%tabs.length;tabs[next].focus();tabs[next].click();});
    });
    views.forEach(function(view){
      view.addEventListener('click',function(){
        var name=view.getAttribute('data-pp-view');
        var source=image&&image.getAttribute('data-'+name+'-src');
        if(!image||!source||name===currentView)return;
        currentView=name;
        closeDetail(false);
        views.forEach(function(item){var active=item===view;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false');});
        updateMarkers();
        setImage(name);
        image.alt='Oreiller ergonomique enfant Pioupiou, vue '+(name==='back'?'de dos':name==='profile'?'de côté':'du dessus');
      });
    });
    var activeDetail=null;
    var zones=Array.prototype.slice.call(root.querySelectorAll('[data-pp-zone]'));
    function closeDetail(restoreFocus){
      if(popover)popover.hidden=true;
      details.concat(zones).forEach(function(item){item.setAttribute('aria-expanded','false');});
      if(restoreFocus&&activeDetail)activeDetail.focus({preventScroll:true});
    }
    function openDetail(button,trigger){
      if(!popover||!button)return;
      closeDetail(false);
      activeDetail=trigger||button;
      popoverTitle.textContent=button.getAttribute('data-detail-title')||'';
      popoverText.textContent=button.getAttribute('data-detail-text')||'';
      activeDetail.setAttribute('aria-expanded','true');
      popover.hidden=false;
      popover.scrollIntoView({behavior:'auto',block:'nearest'});
      if(popoverClose)popoverClose.focus({preventScroll:true});
    }
    details.concat(zones).forEach(function(button){button.setAttribute('aria-controls','PpLabDetail');button.setAttribute('aria-expanded','false');});
    details.forEach(function(button){button.addEventListener('click',function(){openDetail(button);});});
    zones.forEach(function(button){button.addEventListener('click',function(){var copies=root.querySelectorAll('[data-pp-panel="forme"] [data-pp-detail]');openDetail(copies[Number(button.getAttribute('data-pp-zone'))],button);});});
    if(popoverClose)popoverClose.addEventListener('click',function(){closeDetail(true);});
    root.addEventListener('keydown',function(event){if(event.key==='Escape'&&popover&&!popover.hidden){event.preventDefault();closeDetail(true);}});
    tabs.forEach(function(tab,index){tab.tabIndex=index===0?0:-1;});
    updateMarkers();
  }
  function initAll(scope){var roots=(scope||document).querySelectorAll('[data-pp-lab]');Array.prototype.forEach.call(roots,init);if(scope&&scope.matches&&scope.matches('[data-pp-lab]'))init(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

})();